/* Cart functions */

function cartOpenLoading() {
    const cartContainer = document.querySelector('.drawer-cart');
    cartContainer.innerHTML += '<div class="load-container"><div class="load"></div></div>';        
    cartContainer.classList.add('drawn');
    document.querySelector('.background-drawer-cart').classList.add('drawn');
}

// Function to update the selling plan IDs on buttons based on frequency
function updateUpsellProductButtons(frequency) {
  try {
    // Update buttons in the upsell drawer
    const upsellButtons = document.querySelectorAll('.drawer-upsell .quick-add-subscription');
    
    upsellButtons.forEach((button) => {
        // Skip non-subscription buttons
        if (button.dataset.cartPropIntervalunitofmeasure !== 'months') return;
        
        // Get the correct plan ID based on frequency
        let planId;
        
        // Check all possible naming formats for plan IDs
        if (frequency === 0) {
            // For 1-month plans - check various naming formats
            planId = button.dataset.plan1Month || 
                     button.getAttribute('data-plan-1-month') ||
                     button.dataset.planMonth1;
        } else if (frequency === 1) {
            // For 2-month plans
            planId = button.dataset.plan2Month || 
                     button.getAttribute('data-plan-2-month') ||
                     button.dataset.planMonth2;
        } else if (frequency === 2) {
            // For 3-month plans
            planId = button.dataset.plan3Month || 
                     button.getAttribute('data-plan-3-month') ||
                     button.dataset.planMonth3;
        }
        
        // Update the selling plan ID if we found one
        if (planId) {
            button.dataset.cartSellingPlan = planId;
            // Also set the attribute directly to ensure it's updated
            button.setAttribute('data-cart-selling-plan', planId);
        }
    });
    
    // Also update subscription radio buttons on the main product page
    const subscriptionRadios = document.querySelectorAll('input[type="radio"][data-cart-prop-_intervalunitofmeasure="months"]');
    
    subscriptionRadios.forEach((radio) => {
        let planId;
        if (frequency === 0) {
            planId = radio.dataset.plan1Month || radio.getAttribute('data-plan-1-month');
        } else if (frequency === 1) {
            planId = radio.dataset.plan2Month || radio.getAttribute('data-plan-2-month');
        } else if (frequency === 2) {
            planId = radio.dataset.plan3Month || radio.getAttribute('data-plan-3-month');
        }
        
        if (planId) {
            radio.dataset.cartSellingPlan = planId;
            radio.setAttribute('data-cart-selling-plan', planId);
        }
    });
    
    /* 
    // Update the shadow add-to-cart button on the product page
    const shadowButton = document.getElementById('shadow-add-to-cart');
    if (shadowButton) {
        let planId;
        if (frequency === 0) {
            planId = shadowButton.dataset.plan1Month || shadowButton.getAttribute('data-plan-1-month');
        } else if (frequency === 1) {
            planId = shadowButton.dataset.plan2Month || shadowButton.getAttribute('data-plan-2-month');
        } else if (frequency === 2) {
            planId = shadowButton.dataset.plan3Month || shadowButton.getAttribute('data-plan-3-month');
        }
        
        if (planId) {
            shadowButton.dataset.cartSellingPlan = planId;
            shadowButton.setAttribute('data-cart-selling-plan', planId);
        }
    }
    */
  } catch (error) {
    console.error('Error updating buttons:', error);
  }
}

/**
 * Fetches the cart data from the server.
 * @returns {Promise<Object>} A promise that resolves to the cart data.
 * @throws {Error} If there is an error fetching the cart data.
 */
async function fetchCart() {
    try {
        const response = await fetch(`${routes.cart_url}`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/javascript'
            }
        });
        const cart = await response.json();
        return cart;
    } catch (error) {
        console.error('Error fetching cart:', error);
        throw error; // Re-throw the error to handle it outside the function if necessary.
    }
  }
  
  
  /**
   * Updates the cart with the specified updates.
   * @param {Object} updates - The updates to apply to the cart. Can be an object of line numbers and quantities or a simple object of updates.
   * @param {boolean} [useLineNumbers=false] - Indicates whether the updates should be applied using line numbers. Default is false.
   * @param {string} [note=''] - Additional note to include with the updates. Default is an empty string.
   * @param {Object} [attributes={}] - Additional attributes to include with the updates. Should be an object of key-value pairs. Default is an empty object.
   * @returns {Promise<Object>} - A promise that resolves to the updated cart data.
   * @throws {Error} - If there is an error updating the cart.
   */
  async function updateCart(updates, useLineNumbers = false, note = '', attributes = {}, sections = null) {
    try {
        let updatesPayload;
        if (useLineNumbers) {
            updatesPayload = { updates: Object.fromEntries(Object.entries(updates).map(([lineNumber, qty]) => [lineNumber, qty])) };
        } else {
            updatesPayload = { updates };
        }
  
        const requestData = {
            ...updatesPayload,
            ...(note && { note: encodeURIComponent(note) }),
            ...(Object.keys(attributes).length > 0 && { attributes: Object.fromEntries(Object.entries(attributes).map(([k, v]) => [encodeURIComponent(k), encodeURIComponent(v)])) }),
            ...(sections && { sections: sections })
        };
  
        const response = await fetch(`${routes.cart_update_url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/javascript'
            },
            body: JSON.stringify(requestData)
        });
  
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        return await response.json();
    } catch (error) {
        console.error('Error updating cart:', error);
        throw error;
    }
  }
  
  /**
   * Changes the quantity and properties of a cart item.
   * @param {string|number} lineOrId - The line item ID or line item index.
   * @param {number} quantity - The new quantity for the cart item.
   * @param {boolean} [useLine=false] - Indicates whether the line item ID should be used instead of the line item index.
   * @param {Object} [properties={}] - Additional properties to update for the cart item.
   * @param {string|null} [sellingPlan=null] - The selling plan for the cart item.
   * @returns {Promise<Object>} - A promise that resolves to the updated cart item.
   * @throws {Error} - If there is an error changing the cart item.
   */
  async function changeCartItem(lineOrId, quantity, useLine = false, properties = {}, sellingPlan = null, sections = null, cartOpenLoadingBoolean = false) {
    try {
        if (cartOpenLoadingBoolean) {
            cartOpenLoading();
        }

        const requestData = {
            ...(useLine ? { line: lineOrId } : { id: lineOrId }),
            quantity,
            ...(Object.keys(properties).length > 0 && { properties: Object.fromEntries(Object.entries(properties).map(([k, v]) => [encodeURIComponent(k), encodeURIComponent(v)])) }),
            ...(sellingPlan && { selling_plan: sellingPlan }),
            ...(sections && { sections: sections })
        };
  
        const response = await fetch(`${routes.cart_change_url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/javascript'
            },
            body: JSON.stringify(requestData)
        });
  
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        return await response.json();
    } catch (error) {
        console.error('Error changing cart item:', error);
        throw error;
    }
  }
  
  /**
   * Adds items to the cart.
   * @param {Array} items - The items to be added to the cart.
   * @returns {Promise} - A promise that resolves to the updated cart.
   * @throws {Error} - If there is an error adding the item to the cart.
   */
  async function addToCart(items) {
    try {
        cartOpenLoading();
        const response = await fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/javascript'
            },
            body: JSON.stringify(items)
        });
  
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        return await response.json();
    } catch (error) {
        console.error('Error adding item to cart:', error);
        throw error;
    }
  }
  
  /**
   * Clears the cart by making a POST request to the Shopify API.
   * After successfully clearing the cart, fetches the updated cart.
   * @returns {Promise} A promise that resolves with the updated cart.
   * @throws {Error} If there is an error clearing the cart.
   */
  async function clearCart() {
    try {
        
        const response = await fetch(`${routes.cart_clear_url}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/javascript'
            }
        });
  
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        return await response.json();
    } catch (error) {
        console.error('Error clearing cart:', error);
        throw error;
    }
  }

  function buildQuickData(buttonElement, sectionId) {
    const properties = {};
    
    // Check if this is a referrer button pointing to a checked radio
    let sourceElement = buttonElement;
    
    if (buttonElement.dataset.cartReferer) {
        const refererSelector = buttonElement.dataset.cartReferer;
        const refererElement = document.querySelector(refererSelector);
        
        if (refererElement) {
            sourceElement = refererElement;  // Use the referred element for attributes
        } else {
            console.error('Referer element not found with selector:', refererSelector);
        }
    }
    
    // Access all data attributes from the source element
    const dataAttributes = sourceElement.dataset;
        
    // Find data attributes from the source element having cart-prop in the attribute name
    for (const key in dataAttributes) {
        if (dataAttributes.hasOwnProperty(key) && key.startsWith('cartProp')) {
            const propKey = key.slice('cartProp'.length);
            properties[propKey.slice(1)] = dataAttributes[key];
        }
    }
    
    // Get quantity
    let quantity = dataAttributes.cartQuantity || 1;
    
    // Handle quantity when it's a selector
    if(isNaN(quantity) && typeof quantity === 'string') {
        const quantityElement = document.querySelector(quantity);
        quantity = quantityElement ? quantityElement.value : 1;
    }
    
    // Get ID directly from the data attribute if available
    let id = dataAttributes.cartId;
    
    if(isNaN(id)) {
        const idElement = document.querySelector(id);
        if (idElement) {
            id = idElement.value;
        } else {
            console.error('Could not find ID element with selector:', id);
        }
    }
    
    // If data-cart-info-quantity-multiplier is present, multiply the quantity by the multiplier
    if (dataAttributes.cartInfoQuantityMultiplier) {
        quantity = parseInt(quantity) * parseInt(dataAttributes.cartInfoQuantityMultiplier);
    }
    
    // Check for selling plan in data attributes
    let sellingPlan = dataAttributes.cartSellingPlan || sourceElement.getAttribute('data-cart-selling-plan') || null;
    
    // If this is a subscription product (intervalunitofmeasure is 'months')
    // and we have plan IDs for different frequencies, use the current cart frequency
    if (properties._intervalunitofmeasure === 'months') {
        // Get current cart frequency from frequency select or body data attribute
        let cartFrequency = 2; // Default to 3-month (index 2)
        
        const frequencySelect = document.getElementById('frequency');
        if (frequencySelect) {
            cartFrequency = parseInt(frequencySelect.selectedIndex);
        } else if (document.body.dataset.cartFrequency !== undefined) {
            cartFrequency = parseInt(document.body.dataset.cartFrequency);
        }
        
        // Map frequency to the appropriate plan
        if (cartFrequency === 0) {
            // Try different ways to access the 1-month plan ID
            const plan1 = dataAttributes.plan1Month || 
                         sourceElement.getAttribute('data-plan-1-month');
            if (plan1) {
                sellingPlan = plan1;
            }
        } else if (cartFrequency === 1) {
            // Try different ways to access the 2-month plan ID
            const plan2 = dataAttributes.plan2Month || 
                         sourceElement.getAttribute('data-plan-2-month');
            if (plan2) {
                sellingPlan = plan2;
            }
        } else if (cartFrequency === 2 || cartFrequency === undefined) {
            // Try different ways to access the 3-month plan ID
            const plan3 = dataAttributes.plan3Month || 
                         sourceElement.getAttribute('data-plan-3-month');
            if (plan3) {
                sellingPlan = plan3;
            }
        }
    }
    
    // Ensure id is converted to a number if it's a string containing only digits
    if (id && !isNaN(id)) {
        id = parseInt(id);
    }
    
    // CRITICAL: Validate that we have a valid product ID before proceeding
    if (!id) {
        console.error('CRITICAL: No valid product ID found!');
        return null;
    }
    
    const item = {
        id: id,
        quantity: parseInt(quantity),
        properties: properties
    };
    
    // Only add selling_plan if it exists and is not empty
    if (sellingPlan && sellingPlan.trim() !== '') {
        item.selling_plan = parseInt(sellingPlan);
    }
    
    const data = [item];
    
    let structuredData = {
        items: data
    };
    
    if (sectionId) {
        structuredData.sections = sectionId;
    }
    
    return structuredData;
}


class CartFunctionsWrapper extends HTMLElement {
    constructor() {
        super();
        //find button element inside the custom element
        this.button = this.querySelector('button');
        //add click event listener to the button element
        // pass button element as parameter to the onClickHandler method
        this.button.addEventListener('click', this.onClickHandler.bind(this));
    }

    async onClickHandler(event) {
        event.preventDefault();

        if (this.classList.contains('disabled') || this.disabled) {
          return false;
        }

        try {
          // 1. Use cart referer if specified, else fallback to this.button
          const cartReferer = this.dataset.cartReferer;
          const button = cartReferer ? document.querySelector(cartReferer) : this.button;
      
          if (!button) {
            return;
          }
      
          // 2. Build cart data
          const quickData = buildQuickData(button, 'yg-cart-drawer');
      
          // 3. Basic validation
          if (quickData === null) return;
          if (!quickData.items?.[0]?.id) return;
      
          // 4. Proceed with add to cart
          const cartAdd = await addToCart(quickData);
          refreshCart(true, null, cartAdd.sections);
      
        } catch (error) {
          console.error('Error adding to cart:', error);
        }
    }
}

//register the custom element
customElements.define('cart-functions-wrapper', CartFunctionsWrapper);

class CartActionButton extends HTMLElement {
    constructor() {
        super();
        //find .delete-cart-product element inside the custom element
        this.buttonDelete = this.querySelector('.delete-cart-product');        
        this.buttonQuantity = this.querySelector('select[name="quantity"]');
        //add click event listener to the button element
        if (this.buttonDelete) {
            this.buttonDelete.addEventListener('click', this.onEventHandler);
        }
        if (this.buttonQuantity) {
            this.buttonQuantity.addEventListener('change', this.onEventHandler);
        }
    }
    async onEventHandler(event) {
        event.preventDefault();
        try {
            const lineWrapper = this.closest('.cart-product-wrapper');
            const line = parseInt(lineWrapper.dataset.line);
            let cart;
    
            if (event.target.name === 'quantity') {
                const quantity = parseInt(event.target.value);
                cart = await changeCartItem(line, quantity, true, {}, null, 'yg-cart-drawer', true);
                refreshCart(false, cart, cart.sections);
            } else {
                cart = await changeCartItem(line, 0, true, {}, null, 'yg-cart-drawer', true);
                refreshCart(false, cart, cart.sections);
            }
        } catch (error) {
            console.error('Error handling cart item change:', error);
            // Optionally, handle the UI or alert the user.
        }
    }
}

//register the custom element
customElements.define('cart-action-button', CartActionButton);

class CheckoutButton extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.button.addEventListener('click', (event) => this.onClickHandler(event));
    }

    async onClickHandler(event) {
        event.preventDefault();
        if (this.button.classList.contains('disabled')) {
            return false;
        }

        try {
          const cart = await fetchCart();
          const cartItems = cart.items;
          if (cartItems.length === 0) return;
      
          // Always use regular checkout regardless of subscription items
          this.handleRegularCheckout();
          
      } catch (error) {
          console.error('Error processing checkout:', error);
      }
    }

    handleRegularCheckout() {
        const discountCodeElement = this.closest('.drawer-cart').querySelector('.discountcodecoupon');
        const discountCode = discountCodeElement ? `?discount=${discountCodeElement.textContent.trim()}` : '';
        window.location.assign(`/checkout${discountCode}`);
    }

    // Keep these methods for backward compatibility but they won't be used
    async createSubscription() {
        console.warn('createSubscription method is deprecated and no longer used');
        return { subscriptionId: null, checkoutUrl: null };
    }

    async addProductToSubscription(item, subscriptionId) {
        console.warn('addProductToSubscription method is deprecated and no longer used');
        return null;
    }

    async handleSubscriptionCheckout(cartItems) {
        console.warn('handleSubscriptionCheckout method is deprecated, using regular checkout instead');
        this.handleRegularCheckout();
    }
}

customElements.define('checkout-button', CheckoutButton);


async function updateCartAttributes(attributes) {
    try {
      // Prepare attributes in the required format
      const encodedAttributes = Object.fromEntries(
        Object.entries(attributes).map(([key, value]) => [
          encodeURIComponent(key), // Encode keys
          value !== null ? encodeURIComponent(value) : '' // Encode or empty value
        ])
      );
  
      // Use the existing updateCart function to submit the attributes
      const response = await updateCart({}, false, '', encodedAttributes, 'yg-cart-drawer');
      return response; // This response should already be a JSON object
    } catch (error) {
      console.error('Error updating cart attributes:', error);
      throw error;
    }
  }
  











/* custom section */

function handleBodyClickCart(event) {
    if (event.target.closest('.cart-toggler')) {
        toggleCartVisibility(true);
    } else if (event.target.closest('.close-cart, .background-drawer-cart')) {
        toggleCartVisibility(false);
    } else if (event.target.closest('.custom-checkout-btn.disabled')) {
        handleDisabledCheckout(event.target.closest('.custom-checkout-btn.disabled'));
    }
}

function toggleCartVisibility(open) {
    const action = open ? 'add' : 'remove';
    document.querySelector('.drawer-cart')?.classList[action]('drawn');
    document.querySelector('.background-drawer-cart')?.classList[action]('drawn');
    document.body.classList[action]('no-scroll');
}

window.upsellOpenedByDrawer = false;

function handleBodyClickUpsell(event) {
    if (event.target.closest('.close-upsell, .background-drawer-upsell')) {
        toggleUpsellVisibility(false);
        if (!window.upsellOpenedByDrawer) {
            toggleCartVisibility(true);
        }
        window.upsellOpenedByDrawer = false;
    } else if (event.target.closest('.open-upsell')) {
        toggleCartVisibility(false);
        toggleUpsellVisibility(true);
        window.upsellOpenedByDrawer = false;
        
        // When upsell drawer opens, update the frequency on all buttons
        try {
          const frequencySelect = document.getElementById('frequency');
          if (frequencySelect && typeof updateUpsellProductButtons === 'function') {
              const frequency = parseInt(frequencySelect.selectedIndex);
              updateUpsellProductButtons(frequency);
          } else if (document.body.dataset.cartFrequency !== undefined && typeof updateUpsellProductButtons === 'function') {
              // Use stored frequency if no selector exists
              updateUpsellProductButtons(parseInt(document.body.dataset.cartFrequency));
          } else if (typeof updateUpsellProductButtons === 'function') {
              // Default to frequency 2 (3-month) if no frequency selector exists
              updateUpsellProductButtons(2);
          }
        } catch (error) {
          console.error('Error updating upsell buttons:', error);
        }
    } else if (event.target.closest('[data-onclick="drawer"], [href="#upselldrawer"]')) {
        toggleCartVisibility(false);
        toggleUpsellVisibility(true);
        window.upsellOpenedByDrawer = true;
        
        // When upsell drawer opens, update the frequency on all buttons
        try {
          const frequencySelect = document.getElementById('frequency');
          if (frequencySelect && typeof updateUpsellProductButtons === 'function') {
              const frequency = parseInt(frequencySelect.selectedIndex);
              updateUpsellProductButtons(frequency);
          } else if (document.body.dataset.cartFrequency !== undefined && typeof updateUpsellProductButtons === 'function') {
              // Use stored frequency if no selector exists
              updateUpsellProductButtons(parseInt(document.body.dataset.cartFrequency));
          } else if (typeof updateUpsellProductButtons === 'function') {
              // Default to frequency 2 (3-month) if no frequency selector exists
              updateUpsellProductButtons(2);
          }
        } catch (error) {
          console.error('Error updating upsell buttons:', error);
        }
    }
}

function toggleUpsellVisibility(open) {
  const action = open ? 'add' : 'remove';
  document.querySelector('.drawer-upsell')?.classList[action]('drawn');
  document.querySelector('.background-drawer-upsell')?.classList[action]('drawn');
  document.body.classList[action]('no-scroll');
}

function handleDisabledCheckout(button) {
    if (button.dataset.empty) return;

    const notification = document.getElementById('floatingNotification');
    notification.classList.remove('hidden');

    // Scroll the .drawer-cart-wrapper to top smoothly
    document.querySelector('.drawer-cart-wrapper')?.scrollTo({ top: 0, behavior: 'smooth' });

    // Temporarily modify classes for visual feedback
    document.querySelector('.subscription-box')?.classList.add('border-darker');
    document.querySelector('.open-upsell')?.classList.add('button-darker');

    // Revert changes after 3 seconds
    setTimeout(() => {
        notification.classList.add('hidden');
        document.querySelector('.subscription-box')?.classList.remove('border-darker');
        document.querySelector('.open-upsell')?.classList.remove('button-darker');
    }, 3000);
}

async function handleOpenCartOnLoad() {
    const opencart = new URLSearchParams(window.location.search).get('cartopen');
    if (opencart === 'true') {
        toggleCartVisibility(true);
        try {
            const cart = await fetchCart();
            const customCartTotal = calculateCustomCartTotal(cart.items);
            const cartStrings = window.cartStrings; // Assuming cartStrings is globally available
            const sections = null; // Or fetch sections if needed

            // Directly call handleFreeUrlProduct to manage free products
            const { cart: updatedCart, sections: updatedSections } = await handleFreeUrlProduct(cart, customCartTotal, cartStrings, sections);

            // Refresh the cart with updated data if necessary
            refreshCart(true, updatedCart, updatedSections);
        } catch (error) {
            console.error('Error handling free URL product on load:', error);
        }
    }
}

  // Fetch and parse both cart and header HTML content
  async function fetchAndParseCartAndHeader(url) {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
    });
    if (!response.ok) throw new Error('Network response was not ok');
    const data = await response.json();
    const parser = new DOMParser();

    const cartHtmlDoc = parser.parseFromString(data['yg-cart-drawer'], 'text/html');

    const cartHTML = cartHtmlDoc.querySelector('#shopify-section-yg-cart-drawer .drawer-cart').innerHTML;

    return { cartHTML };
  }
  // Show promotion notifications
  function showPromotionNotificationDisplay() {
    if (window.notificationPromo !== '') {
      const promoNotification = document.querySelector('.promotion-notification');
      document.getElementById('promotion-notification-product').textContent = window.notificationPromo;
      promoNotification.classList.remove('hidden');

      setTimeout(() => {
        promoNotification.classList.add('hidden');
      }, 4000);
      window.notificationPromo = '';
    }
  }

  function calculateCustomCartTotal(cartItems) {
    let customCartTotal = 0;

    cartItems.forEach((item) => {
      if (item.properties._intervalunitofmeasure === 'months') {
        // For subscription items, use original_price directly without additional discount
        // since it already includes the subscription discount
        const subscriptionPrice = item.original_price * item.quantity;
        customCartTotal += subscriptionPrice;
      } else if (item.properties._gratis_product === 'true') {
        // Assuming you don't want to add anything if it's a gratis product
      } else if (item.properties._is_pack === 'true') {
        customCartTotal += item.final_price * item.quantity;
      } else {
        customCartTotal += item.final_line_price;
      }
    });

    return customCartTotal;
  }

  function isSubscriptionAvailable(cartItems) {
    return cartItems.some((item) => item.properties && item.properties._intervalunitofmeasure === 'months');
  }

  async function handleGratisProducts(gratis_products, cart, subscriptionAvailable, custom_cart_total, sections) {
    let updatedCart = cart;
    let updatedSections = sections;
    for (const gratis_product of gratis_products) {
      const gratisAdded =
      updatedCart.attributes && updatedCart.attributes[`gratis_product_added_${gratis_product.variant_id}`] === 'true';

      if (gratis_product.subscription) {
        if (subscriptionAvailable && !gratisAdded) {
          const returnedData = await addToCart({
            items: [
              {
                id: parseInt(gratis_product.variant_id),
                quantity: 1,
                properties: {
                  _firmhouseid: parseInt(gratis_product.firmhouse_id),
                  _intervalunitofmeasure: 'default',
                  _gratis_product: 'true',
                },
              },
            ],
            attributes: { [`gratis_product_added_${gratis_product.variant_id}`]: 'true' },
            sections: 'yg-cart-drawer',
          });
          const cart = await fetchCart();
          updatedCart = cart;
          updatedSections = returnedData.sections;
        } else if (!subscriptionAvailable && gratisAdded) {
          const line = findLineForGratisProduct(updatedCart, gratis_product.variant_id);
          await changeCartItem(line, 0, true); // Remove the gratis product
          const returnedData = await updateCart({}, false, '', { [`gratis_product_added_${gratis_product.variant_id}`]: 'false' }, 'yg-cart-drawer');
          updatedCart = returnedData;
          updatedSections = returnedData.sections;
        }
      } else {
        if (custom_cart_total / 100 >= gratis_product.threshold && !gratisAdded) {
          const returnedData = await addToCart({
            items: [
              {
                id: parseInt(gratis_product.variant_id),
                quantity: 1,
                properties: {
                  _firmhouseid: parseInt(gratis_product.firmhouse_id),
                  _intervalunitofmeasure: 'default',
                  _gratis_product: 'true',
                },
              },
            ],
            attributes: { [`gratis_product_added_${gratis_product.variant_id}`]: 'true' },
            sections: 'yg-cart-drawer',
          });
          const cart = await fetchCart();
          updatedCart = cart;
          updatedSections = returnedData.sections;
        } else if (custom_cart_total / 100 < gratis_product.threshold && gratisAdded) {
          const line = findLineForGratisProduct(updatedCart, gratis_product.variant_id);
          await changeCartItem(line, 0, true); // Remove the gratis product
          const returnedData = await updateCart({}, false, '', { [`gratis_product_added_${gratis_product.variant_id}`]: 'false' }, 'yg-cart-drawer');
          updatedCart = returnedData;
          updatedSections = returnedData.sections;
        }
      }
    }
    // return both the updated cart and sections
    return { cart: updatedCart, sections: updatedSections };
  }

  async function handleFreeUrlProduct(cart_update, custom_cart_total, cartStrings, sections) {
    let updatedCart = cart_update;
    let updatedSections = sections;
    const urlGift = cart_update.attributes.url_gift;

    // Use a for...of loop to handle async operations correctly
    for (let index = 0; index < cartStrings.free_url_product.length; index++) {
        const product = cartStrings.free_url_product[index];
        if (cartStrings.free_url_product_available[index] === 'true') {
            const productInCart = cart_update.items.some(
                item => item.variant_id == parseInt(cartStrings.free_url_product_available_id[index]) &&
                        item.properties._gratis_product == 'true'
            );

            const thresholdMet = custom_cart_total / 100 >= parseInt(cartStrings.free_url_threshold[index]);

            // Add the product if not already in cart, threshold is met, and it matches the gift parameter
            if (!productInCart && thresholdMet && product === urlGift) {
                const returnedData = await addToCart({
                    items: [{
                        id: parseInt(cartStrings.free_url_product_available_id[index]),
                        quantity: 1,
                        properties: {
                            _firmhouseid: parseInt(cartStrings.free_firmhouse_id[index]),
                            _intervalunitofmeasure: 'default',
                            _gratis_product: 'true',
                        }
                    }],
                    attributes: { url_gift: 'false' },
                    sections: 'yg-cart-drawer',
                });
                updatedCart = await fetchCart();
                updatedSections = returnedData.sections;
            }

            // Remove the product if it's in the cart and below the threshold or if it's the only item
            if ((productInCart && !thresholdMet) || (cart_update.items.length == 1 && productInCart)) {
                let line = cart_update.items.findIndex(
                    item => item.properties._gratis_product == 'true' &&
                            item.variant_id == parseInt(cartStrings.free_url_product_available_id[index])
                ) + 1;  // Convert 0-based index to 1-based line number for cart manipulation

                if (line > 0) {
                    const returnedData = await changeCartItem(line, 0, true, {}, null, 'yg-cart-drawer');
                    updatedCart = returnedData;
                    updatedSections = returnedData.sections;
                }
            }
        }
    }

    return { cart: updatedCart, sections: updatedSections };
}

  function findLineForGratisProduct(cart, variantId) {
    const index = cart.items.findIndex(
      (item) => item.properties._gratis_product === 'true' && item.variant_id === parseInt(variantId)
    );
    return index + 1; // line numbers are 1-based
  }

  // ========= Gift product script :STARTS =========
  async function checkGratisProductEligibility(data, sections = null) {
    const gratis_products = gratis_products_glob;
    let cart = data;
    let cart_update = data;
    let custom_cart_total = calculateCustomCartTotal(cart.items);
    let subscriptionAvailable = isSubscriptionAvailable(cart.items);
    let newSections = sections;
    if (_learnq) {
      _learnq.push([
        'track',
        'Added to Cart',
        {
          total_price: custom_cart_total / 100,
          $value: custom_cart_total / 100,
          items: cart.items,
        },
      ]);
    }

    showPromotionNotification(localStorage.getItem('old-cart-total'), custom_cart_total);

    // update cart and sections with new values
    
    const { cart: updatedCart, sections: updatedSections } = await handleGratisProducts(gratis_products, cart, subscriptionAvailable, custom_cart_total, newSections);
    cart_update = updatedCart;
    newSections = updatedSections;

    const { cart: updatedCartURL, sections: updatedSectionsURL } = await handleFreeUrlProduct(cart_update, custom_cart_total, cartStrings, newSections)
    cart_update = updatedCartURL;
    newSections = updatedSectionsURL;

    return { cart: cart_update, sections: newSections };
  }
  // ========= Gift product script :ENDS =========

  // ========= Check if subscription product available in cart :STARTS =========
  function checkIfSubscriptionProductAvailableInCart(cartItems) {
    const subscriptionSingle = document.querySelector('.subscription-option.subscription-single-quantity-option');
    const subscriptionMultiple = document.querySelector('.subscription-option.subscription-multiple-quantity-option');

    // Ensure elements are found in the DOM before proceeding
    if (!subscriptionSingle || !subscriptionMultiple) {
      return; // Exit the function if elements are not found
    }

    let subscriptionAvailable = isSubscriptionAvailable(cartItems);

    if (subscriptionAvailable) {
      subscriptionSingle.classList.remove('no-disp');
      subscriptionMultiple.classList.add('no-disp');
      subscriptionMultiple.classList.remove('active');

      const singleInput = subscriptionSingle.querySelector('input');
      const multipleInput = subscriptionMultiple.querySelector('input');

      if (multipleInput && multipleInput.checked) {
        subscriptionSingle.classList.add('active');
        singleInput.checked = true;
      }
    } else {
      subscriptionMultiple.classList.remove('no-disp');
      subscriptionSingle.classList.add('no-disp');
      subscriptionSingle.classList.remove('active');

      const singleInput = subscriptionSingle.querySelector('input');
      const multipleInput = subscriptionMultiple.querySelector('input');

      if (singleInput && singleInput.checked) {
        subscriptionMultiple.classList.add('active');
        multipleInput.checked = true;
      }
    }
  }
  // ========= Check if subscription product available in cart :ENDS =========

  // Main function to refresh the cart
  async function refreshCart(openCart = true, cartData = null, sections = null) {
    const cartContainer = document.querySelector('.drawer-cart');
    let updatedSections = sections;
    if (!cartContainer.querySelector('.load-container')) {
      cartContainer.innerHTML += '<div class="load-container"><div class="load"></div></div>';
    }

    if (openCart) {
      cartContainer.classList.add('drawn');
      document.querySelector('.background-drawer-cart').classList.add('drawn');
    }

    try {
      let data = cartData ? cartData : await fetchCart();
      const { cart: cart_update, sections: newSections } = await checkGratisProductEligibility(data, sections);
      updatedSections = newSections;
      data = cart_update;
      const cartItems = data ? data.items : [];
      checkIfSubscriptionProductAvailableInCart(cartItems);
      
      // Store cart frequency in data attribute for easy access
      if (data.attributes && data.attributes.cart_frequency !== undefined) {
        document.body.dataset.cartFrequency = data.attributes.cart_frequency;
        
        // Also update the frequency select dropdown to match the cart frequency
        const frequencySelect = document.getElementById('frequency');
        if (frequencySelect && frequencySelect.selectedIndex !== parseInt(data.attributes.cart_frequency)) {
          frequencySelect.selectedIndex = parseInt(data.attributes.cart_frequency);
        }
        
        // After cart refresh, ensure UI consistency by updating all subscription elements
        try {
          const frequency = parseInt(data.attributes.cart_frequency);
          if (typeof updateUpsellProductButtons === 'function') {
            updateUpsellProductButtons(frequency);
          }
        } catch (error) {
          console.error('Error updating subscription elements:', error);
        }
      }

      const rootUrl = routes.root_url === '/' ? '' : routes.root_url;
      const cartUrl = `${rootUrl}/?sections=yg-cart-drawer`;

      let cartHTML;

      if (!updatedSections) {
        // If sections are not provided, fetch them
        const fetchedSections = await fetchAndParseCartAndHeader(cartUrl);
        cartHTML = fetchedSections.cartHTML;
      } else {
        // Use provided sections
        const parser = new DOMParser();
        const cartHtmlDoc = parser.parseFromString(updatedSections['yg-cart-drawer'], 'text/html');

        cartHTML = cartHtmlDoc.querySelector('#shopify-section-yg-cart-drawer .drawer-cart').innerHTML;
      }
      // Update DOM elements
      cartContainer.innerHTML = cartHTML;
      
      // Ensure frequency selector is updated after HTML replacement
      if (data.attributes && data.attributes.cart_frequency !== undefined) {
        const frequencySelect = document.getElementById('frequency');
        if (frequencySelect) {
          const targetFrequency = parseInt(data.attributes.cart_frequency);
          
          // Only update if the current selection is different
          if (frequencySelect.selectedIndex !== targetFrequency) {
            // Set both the value and selectedIndex for cross-browser compatibility
            // But do NOT dispatch any events to avoid infinite loops
            frequencySelect.value = frequencySelect.options[targetFrequency]?.value || targetFrequency;
            frequencySelect.selectedIndex = targetFrequency;
          }
        }
      }
      
      if (data.item_count == 0) {
        document.querySelector('.cart-count-bubble').classList.add('no-disp');
        document.querySelector('.cart-count-bubble-text').textContent = data.item_count;
      } else {
        document.querySelector('.cart-count-bubble').classList.remove('no-disp');
        document.querySelector('.cart-count-bubble-text').textContent = data.item_count;
      }

      showPromotionNotificationDisplay();
    } catch (error) {
      console.error('Failed to fetch or update cart:', error);
    } finally {
      // if upsell is open, close it and open cart
      if (document.querySelector('.drawer-upsell').classList.contains('drawn')) {
        toggleUpsellVisibility(false);
        toggleCartVisibility(true);
      }
      const loadContainer = document.querySelector('.load-container');
      if (loadContainer) loadContainer.remove();
    }
  }

  async function fetchDiscountCode(couponCode) {
    try {
        const response = await fetch('/apps/subscriptions/getShopifyDiscountByCode', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ couponCode })
        });

        if (!response.ok) {
            throw new Error('Failed to fetch discount code');
        }

        const data = await response.json();
        const discountCode = data.data.codeDiscountNodeByCode;

        if (discountCode !== null) {
          if(discountCode.codeDiscount.status === 'ACTIVE') {
            const discountPercent = discountCode.codeDiscount.customerGets.value.percentage || null;
            const discountFixedAmount = discountCode.codeDiscount.customerGets.value.amount
                ? discountCode.codeDiscount.customerGets.value.amount.amount
                : null;

            const cartUpdateReturn = await updateCartAttributes({
                'discount-code-applied': couponCode,
                'discount-percent-applied': discountPercent,
                'discount-amount-applied': discountFixedAmount
            });
            showFloatingNotification(couponCode);
            refreshCart(false, cartUpdateReturn, cartUpdateReturn.sections);
          }
        }
    } catch (error) {
        console.error('There was an error fetching the discount code:', error);
    }
}

function showFloatingNotification(couponCode, freeGift = false) {
    const notificationElement = document.createElement('div');
    notificationElement.className = 'floatingcouponapplied';
    if (freeGift) {
      notificationElement.innerHTML = `${couponCode}<span class="close-floatingcouponapplied">${cartStrings.icon_close_small}</span>`;
    } else {
      notificationElement.innerHTML = `🎉 Kortingscode ${couponCode} toegevoegd <span class="close-floatingcouponapplied">${cartStrings.icon_close_small}</span>`;
    }
    
    document.body.appendChild(notificationElement);

    setTimeout(() => {
        notificationElement.remove();
    }, 8000);

    notificationElement.querySelector('.close-floatingcouponapplied').addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent the click event from bubbling up to the parent element
        notificationElement.remove();
    });
}

function showPromotionNotification(oldCartTotal, newCartTotal) {
    // show notification if threshold is passed

    const gratis_promo = gratis_promotions_glob;
    let promo_name = '';
    gratis_promo.forEach(function (gratis_promo_single) {
      const threshold_multiplier = gratis_promo_single.threshold * 100;
      if (oldCartTotal < threshold_multiplier && newCartTotal >= threshold_multiplier) {
        promo_name = gratis_promo_single.name;
      }
    });

    if (promo_name != '') {
      window.notificationPromo = promo_name;
    }
    localStorage.setItem('old-cart-total', newCartTotal);
  }

  async function addFreeProductToCart(productId) {
      try {
          const cartAdd = await addToCart({
              items: [{
                  id: parseInt(productId),
                  quantity: 1,
                  properties: {
                      _firmhouseid: parseInt(cartStrings.free_firmhouse_id),
                      _intervalunitofmeasure: 'default',
                      _gratis_product: 'true',
                  }
              }],
              sections: 'yg-cart-drawer'
          });
          refreshCart(true, null, cartAdd.sections);      
      } catch (error) {
          console.error('Error adding free product to cart:', error);
      }
  }

  async function handleFreeUrlProductOnLoad() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (!urlParams.has('gift')) return;
    const giftParam = urlParams.get('gift');

    const productIndex = window.cartStrings.free_url_product.findIndex(product => product === giftParam);

    if (productIndex === -1) return;

    try {
        const cart = await fetchCart();
        if (!cart || !cart.items) return;

        const productInCart = cart.items.some(item =>
            item.variant_id == parseInt(window.cartStrings.free_url_product_available_id[productIndex]) &&
            item.properties._gratis_product == 'true'
        );

        if (!productInCart && cart.attributes.url_gift !== window.cartStrings.free_url_product[productIndex]) {
            const customCartTotal = calculateCustomCartTotal(cart.items);
            const threshold = parseInt(window.cartStrings.free_url_threshold[productIndex]);

            if (cart.items.length > 0 && customCartTotal / 100 >= threshold) {
                await addFreeProductToCart(window.cartStrings.free_url_product_available_id[productIndex]);
            } else {
                await updateCartAttributes({
                    'url_gift': window.cartStrings.free_url_product[productIndex]
                });
            }
            showFloatingNotification(window.cartStrings.display_url_text[productIndex], true);
        }
    } catch (error) {
        console.error('Error handling free URL product:', error);
    }
}

  window.notificationPromo = '';
  var _learnq = _learnq || [];


  function createStickyVisibilityChecker(stickyElementId, targetElementSelector, offset = 0) {
    const stickyElement = document.getElementById(stickyElementId);
    const targetElement = document.querySelector(targetElementSelector);
  
    // Check if the elements exist
    if (!stickyElement || !targetElement) {
      return;
    }
  
    // Function to check if the target element is out of view
    function checkVisibility() {
      const rect = targetElement.getBoundingClientRect();
      if (rect.top < offset) {
        stickyElement.style.display = 'flex'; // Show the sticky element
      } else {
        stickyElement.style.display = 'none'; // Hide the sticky element
      }
    }
  
    // Check visibility on scroll
    window.addEventListener('scroll', checkVisibility);
  
    // Initial check in case the element is already out of view
    checkVisibility();
  }

  function handleQuickAddSubscriptionLoader(event) {
      const svgElement = this.querySelector('svg');

      if (svgElement) {
          svgElement.style.display = 'none'; // Hide the SVG

          const spinnerDiv = document.createElement('div');
          spinnerDiv.className = 'spinner';
          svgElement.parentElement.appendChild(spinnerDiv);

          setTimeout(() => {
              spinnerDiv.remove();
              svgElement.style.display = ''; // Show the SVG back after 2 seconds
          }, 2000);
      }
  }

  function handleIngredientClick(e) {
    // Close all popups first
    document.querySelectorAll('.yummuy_product_ingridents--col--desc_popup').forEach(popup => {
        popup.classList.remove('open_popup');
    });

    // Check if the click was not on or inside a close button
    if (!e.target.classList.contains('close_popup_ingredients') && !e.target.closest('.close_popup_ingredients')) {
        const targetElement = e.target.closest('.yummuy_product_ingridents--col');
        if (targetElement) {
            const popupId = targetElement.getAttribute('data-id');
            const popup = document.querySelector('.yummuy_product_ingridents--col--desc_popup#' + popupId);
            if (popup) {
                popup.classList.add('open_popup');
            }
        }
    }
}

function closePopupIngredients() {
    // Close all popups
    document.querySelectorAll('.yummuy_product_ingridents--col--desc_popup').forEach(popup => {
        popup.classList.remove('open_popup');
    });
}


document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function(event) {
    handleBodyClickCart(event);
    handleBodyClickUpsell(event);

    if (event.target.closest('.yummuy_product_ingridents--col')) {
        handleIngredientClick(event);
    } else if (event.target.closest('.close_popup_ingredients')) {
        closePopupIngredients();
    }
  });
  handleOpenCartOnLoad();

  document.querySelectorAll('.quick-add-subscription').forEach(button => {
    button.addEventListener('click', handleQuickAddSubscriptionLoader);
  });

  document.body.addEventListener('change', event => {
      if (event.target.matches('#frequency')) {
          const frequency = event.target.selectedIndex;
          
          // First, update the cart attribute
          updateCartAttributes({
              'cart_frequency': frequency
          });
          
          // Dispatch custom event to notify product.js about the frequency change
          document.dispatchEvent(new CustomEvent('cart:frequency:updated', {
              detail: {
                  frequency: frequency
              }
          }));
          
          // Now, update the selling plans of subscription items in the cart
          updateCartSubscriptionPlans(frequency, event.target);
          
          // Also update all upsell drawer subscription buttons
          try {
            if (typeof updateUpsellProductButtons === 'function') {
              updateUpsellProductButtons(frequency);
            }
          } catch (error) {
            console.error('Error updating upsell buttons on frequency change:', error);
          }
      }
  });
  
  // Function to update selling plans for all subscription items in the cart
  async function updateCartSubscriptionPlans(frequency, frequencySelect) {
      try {
          // Show loading indicator immediately
          cartOpenLoading();
          
          // Map frequency index to months for search
          const frequencyMonths = frequency + 1; // 0 → 1 month, 1 → 2 months, 2 → 3 months
          
          // Add a small delay before refreshing to ensure server processing is complete
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // Get the current cart to identify subscription items
          const cart = await fetchCart();
          const updates = [];
          const incompatibleProducts = [];
          
          // Process each subscription item individually
          for (const [index, item] of cart.items.entries()) {
              // Skip if not a subscription item
              if (!item.properties || item.properties._intervalunitofmeasure !== 'months') continue;
              
              try {
                  // Fetch product data to get available selling plans for this specific product
                  const productHandle = item.handle || item.product_title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
                  const response = await fetch(`/products/${productHandle}.js`);
                  const productData = await response.json();
                  
                  // Find the appropriate selling plan for this product based on frequency
                  let matchingPlanId = null;
                  
                  // Look through all selling plan groups for this product
                  for (const group of productData.selling_plan_groups || []) {
                      // Look at each selling plan in the group
                      for (const plan of group.selling_plans || []) {
                          // Check if this plan matches our desired frequency (1, 2, or 3 months)
                          const planOptions = plan.options && plan.options[0];
                          const value = planOptions && planOptions.value;
                          
                          // Check if this plan is for recurring deliveries and matches our frequency
                          if (plan.recurring_deliveries === true && 
                              value && 
                              value.includes(`${frequencyMonths} MONTH`)) {
                              matchingPlanId = plan.id;
                              break;
                          }
                      }
                      if (matchingPlanId) break;
                  }
                  
                  // If we found a matching plan, add it to updates
                  if (matchingPlanId) {
                      updates.push({
                          line: index + 1, // Convert 0-based index to 1-based line number
                          quantity: item.quantity,
                          selling_plan: matchingPlanId
                      });
                  } else {
                      incompatibleProducts.push(item.product_title);
                  }
              } catch (error) {
                  console.warn(`Could not find selling plans for ${item.product_title}:`, error);
                  incompatibleProducts.push(item.product_title);
              }
          }
          
          // If we have subscription items to update
          if (updates.length > 0) {
              // Update each subscription item one by one
              for (const update of updates) {
                  try {
                      await changeCartItem(
                          update.line,
                          update.quantity,
                          true, // use line
                          {}, // keep existing properties
                          update.selling_plan,
                          'yg-cart-drawer'
                      );
                  } catch (error) {
                      console.warn(`Failed to update ${update.product_title}:`, error);
                      incompatibleProducts.push(update.product_title);
                  }
              }
              
              // Add a small delay before refreshing to ensure server processing is complete
              await new Promise(resolve => setTimeout(resolve, 1000));
              
              // Show warning if any products couldn't be updated
              if (incompatibleProducts.length > 0) {
                  console.warn(`These products couldn't be updated to ${frequencyMonths}-month frequency:`, 
                               incompatibleProducts.join(', '));
              }
              
              // Refresh the cart with updated data
              const updatedCart = await fetchCart();
              refreshCart(false, updatedCart);
          }
      } catch (error) {
          console.error('Error updating subscription selling plans:', error);
      }
  }

  const urlDiscountParam = new URLSearchParams(window.location.search).get('discount');
  if (urlDiscountParam) {
      const couponCode = urlDiscountParam;
      fetchDiscountCode(couponCode);
  }

  document.body.addEventListener('click', async event => {
      if (event.target.matches('.removediscountcode') || event.target.closest('.removediscountcode')) {          
          cartOpenLoading();
          const cartUpdateReturn = await updateCartAttributes({
              'discount-code-applied': null,
              'discount-percent-applied': null,
              'discount-amount-applied': null
          });
          refreshCart(false, cartUpdateReturn, cartUpdateReturn.sections);
      }
  });

  handleFreeUrlProductOnLoad();
});

